<div class="card-scoreboard_players">
    <div class="cell">{{ eventName }}</div>
    <div class="cell"></div>
</div>
